// frontend/src/lib/recipe-shopping-text.ts
import { scaleAmount, formatQty } from './servings';

const APP_URL = 'https://t.me/recipt_help_Bot/app';

// Принимает и ингредиенты рецепта (productName), и extraIngredients (name).
export interface RecipeShoppingIngredient {
  productId?: string;
  productName?: string;
  name?: string;
  amount?: number | null;
  unit?: string | null;
  isOptional?: boolean;
}

export interface BuildRecipeShoppingTextInput {
  title: string;
  servings: number | undefined;
  n: number;
  ingredients: RecipeShoppingIngredient[];
  extras?: RecipeShoppingIngredient[];
  pantryIds: Set<string>;
}

function line(ing: RecipeShoppingIngredient, servings: number | undefined, n: number): string {
  const name = (ing.productName ?? ing.name ?? '').trim();
  const opt = ing.isOptional ? ' (по желанию)' : '';
  const qty = formatQty(scaleAmount(ing.amount, servings, n, ing.unit), ing.unit);
  return `• ${name}${opt} — ${qty}`;
}

// Текст списка покупок по одному рецепту: всё на N человек, две секции
// «Купить» (чего нет дома) и «Уже есть дома». Плоский список (категорий у
// ингредиентов рецепта нет). Пустой ввод → '' (кнопки не показываем).
export function buildRecipeShoppingText(input: BuildRecipeShoppingTextInput): string {
  const { title, servings, n, ingredients, extras = [], pantryIds } = input;
  const all = [...ingredients, ...extras];
  if (all.length === 0) return '';

  const toBuy: RecipeShoppingIngredient[] = [];
  const haveHome: RecipeShoppingIngredient[] = [];
  for (const ing of all) {
    const have = !!ing.productId && pantryIds.has(ing.productId);
    (have ? haveHome : toBuy).push(ing);
  }

  const blocks: string[] = [`🛒 ${title}${servings ? ` — на ${n} чел.` : ''}`];
  if (toBuy.length) blocks.push(`\nКупить:\n${toBuy.map((i) => line(i, servings, n)).join('\n')}`);
  if (haveHome.length) blocks.push(`\nУже есть дома:\n${haveHome.map((i) => line(i, servings, n)).join('\n')}`);
  blocks.push(`\nСобрано в Рецепт.ИИ: ${APP_URL}`);
  return blocks.join('\n');
}
